<!-- footer component -->
<div class="footer" >
    <p>Copyright © {{currentYear}} NowAccount Network Corporation, All rights reserved. NowAccount®, NowNetwork®, and Now® are registered trademarks of NowAccount Network Corporation.</p>   
</div>